import MySearchesModule from './MySearchesModule'
export default MySearchesModule
